import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from '../Button';

const DashedButton = ({
  buttonProps,
  children,
  className,
  onClick,
  wrapperProps
}) => (
  <div
    className={classnames('btn--dash', 'card__btn', className)}
    {...wrapperProps}
  >
    <hr />
    <Button variant='tertiary' onClick={onClick} outline {...buttonProps}>
      {children}
    </Button>
    <hr />
  </div>
);

DashedButton.defaultProps = {
  children: 'Show More'
};

DashedButton.propTypes = {
  buttonProps: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  wrapperProps: PropTypes.object
};

export default DashedButton;
